import { Injectable } from '@angular/core';
import { CustomHttpService } from './custom-http.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: CustomHttpService) { }

  getAllCampus(body:any):Observable<any> {
    return this.http.post(environment.getAllCampus,body);
  }

}
